import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const DevelopmentLayout = ({ 
  title, 
  categories = [], 
  selectedCategory, 
  onCategoryChange, 
  children 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-8 pb-6">
          {/* Title */}
          <div className="flex justify-center">
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="flex items-center"
            >
              <Sparkles className="w-8 h-8 text-primary-600" />
              <h1 className="text-2xl font-bold text-primary-600 ml-3 !mb-0">{title}</h1>
            </motion.div>
          </div>

          {/* Category Navigation */}
          <div className="flex justify-center mt-12 mb-12">
            <motion.div 
              className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg dark:shadow-gray-900/20 p-2 overflow-x-auto max-w-full"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <div className="flex space-x-1">
                {categories.map((category) => {
                  const isActive = selectedCategory === category.id;
                  return (
                    <motion.button
                      key={category.id}
                      onClick={() => onCategoryChange(category.id)}
                      className={`relative px-6 py-3 rounded-xl whitespace-nowrap
                        transition-all duration-200 ${
                        isActive
                          ? 'text-white'
                          : 'text-gray-600 dark:text-gray-300 hover:text-primary-600 hover:bg-primary-50 dark:hover:text-primary-400 dark:hover:bg-gray-700'
                      }`}
                    >
                      {isActive && (
                        <motion.div
                          layoutId="active-category"
                          className="absolute inset-0 bg-gradient-to-r from-primary-500 to-primary-600 rounded-xl"
                          initial={false}
                          transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                        />
                      )}
                      <span className="relative flex items-center space-x-2">
                        <category.icon className="w-5 h-5" />
                        <span className="font-medium">{category.label}</span>
                      </span>
                    </motion.button>
                  );
                })}
              </div>
            </motion.div>
          </div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            {children}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default DevelopmentLayout;
